import { Component, computed, inject, Input } from '@angular/core';
import { BuildingItemDto, BuildingService, SortDto } from '@artemis-software/wr-api';
import { loader } from '@/utils/signals/loader';
import { Tracked } from '@/utils/signals/tracked';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { AuthService } from '@services/auth.service';

@Component({
  standalone: false,
  selector: 'wr-tenant-dashboard-building-overview',
  templateUrl: './tenant-dashboard-building-overview.component.html',
})
export class TenantDashboardBuildingOverviewComponent {
  buildingService = inject(BuildingService);
  service = inject(AuthService);

  isLoading = loader();

  @Input()
  @Tracked()
  tenantId!: string;

  @Tracked() page = 0;
  @Tracked() pageSize = 10;
  @Tracked() sort: SortDto = { sort: 'sectionText', order: 'DESC' };

  results = asyncComputed(() => {
    if (!this.tenantId) {
      return undefined;
    }
    return this.buildingService.findAllPaginated({
      ownerTenantId: this.tenantId,
      page: this.page,
      size: this.pageSize,
      sort: {
        sort: this.sort.sort,
        order: this.sort.order,
      }
    });
  }, undefined, this.isLoading);

  buildings = computed(() => this.results()?.items ?? []);

  buildingCount = computed(() => this.results()?.totalItems ?? 0);

  readonly getBuildingLink = (building: BuildingItemDto) => (['building', building.id]);
}
